import graphQl from '../../../../services/graphQl';
import store from '@/store';
import { Commit, ActionTree, MutationTree, Dispatch } from 'vuex';
import { AxiosResponse } from 'axios';
import rootStateStore, { State } from './apmCommonState.store';
import { parseServiceObjFromApplication } from '../../../../utils/helper-function';

const actions: ActionTree<State, any> = {
  getServices(
    context: { commit: Commit },
    params: { duration: any; serviceReq: any },
  ) {
    if (!params.serviceReq) {
      params.serviceReq = {
        capability: 'A',
      };
    }
    return graphQl
      .query('queryServices')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit('setServices', res.data.data.services);
      });
  },
  getServiceEndpoints(
    context: { commit: Commit; state: any },
    params: { keyword: string },
  ) {
    if (!context.state.currentService.key) {
      context.commit('setEndpoints', []);
      return;
    }
    if (!params.keyword) {
      params.keyword = '';
    }
    return graphQl
      .query('queryEndpoints')
      .params({ serviceId: context.state.currentService.key || '', ...params })
      .then((res: AxiosResponse) => {
        context.commit('setEndpoints', res.data.data.getEndpoints);
      })
      .catch((err) => console.log(err));
  },
  getEndpoints(context: { commit: Commit }, params: any) {
    return graphQl
      .query('queryEndpoints')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit('setEndpoints', res.data.data.endpoints);
      })
      .catch((err) => console.log(err));
  },
  getServiceInstances(context: { commit: Commit; state: any }, params: any) {
    if (!context.state.currentService.key) {
      context.commit('setInstances', []);
      return;
    }
    return graphQl
      .query('queryInstances')
      .params({ serviceId: context.state.currentService.key || '', ...params })
      .then((res: AxiosResponse) => {
        context.commit('setInstances', res.data.data.getServiceInstances);
      })
      .catch((err) => console.log(err));
  },
  getInstances(context: { commit: Commit }, params: any) {
    return graphQl
      .query('queryInstances')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit('setInstances', res.data.data);
      })
      .catch((err) => console.log(err));
  },
  async getServiceLanguage(
    context: { commit: Commit; state: any },
    params: any,
  ) {
    return graphQl
      .query('queryServiceLanguage')
      .params({
        serviceId: params?.serviceId ?? context.state.currentService.key,
      })
      .then((res: AxiosResponse) => {
        if (!res.data.errors) {
          context.commit('setCurrentServiceLanguage', res.data.data.Language);
        }
      })
      .catch((err) => {
        console.log('LANG Error: ', err);
      });
  },
  getDatabases(context: { commit: Commit; rootState: any }, params: any) {
    return graphQl
      .query('queryDatabases')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit('setDatabases', res.data.data.services);
      })
      .catch((error) => console.log(error));
  },
  getServiceDatabases(
    context: { commit: Commit; rootState: any },
    params: { serviceId: string; duration: string },
  ) {
    if (!params.serviceId) {
      return new Promise<void>((resolve) => resolve());
    }
    return graphQl
      .query('queryDatabaseService')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit('setDatabases', res.data.data.services);
      })
      .catch((error) => console.log(error));
  },
  selectService(context: { commit: Commit; dispatch: Dispatch }, params: any) {
    if (!params.service.key) {
      return;
    }
    // window.localStorage.setItem(
    //   'currentService',
    //   JSON.stringify(params.service)
    // );
    const { sub } = parseServiceObjFromApplication(params.service);
    context.commit('setCurrentService', params.service);
    context.commit('setCurrentSubType', sub);
    if (store.getters['globalState/app/sideNav'].name !== 'Settings') {
      context.dispatch('getServiceEndpoints', { duration: params.duration });
      context.dispatch('getServiceInstances', { duration: params.duration });
      context.dispatch('getServiceDatabases', {
        duration: params.duration,
        serviceId: params.service.key,
      });
      context.dispatch('getServiceLanguage', {});
    }
  },
  selectEndpoint(
    context: { commit: Commit; dispatch: Dispatch; state: any; rootState: any },
    params: any,
  ) {
    context.commit('setCurrentEndpoint', params.endpoint);
  },
  selectInstance(
    context: { commit: Commit; dispatch: Dispatch; state: any; rootState: any },
    params: any,
  ) {
    context.commit('setCurrentInstance', params.instance);
  },
  selectDatabase(context: { commit: Commit; dispatch: Dispatch }, params: any) {
    context.commit('setCurrentDatabase', params);
    // context.dispatch('RUN_EVENTS', {}, { root: true });
  },
  getApmData(
    context: { commit: Commit; dispatch: Dispatch; state: State; getters: any },
    params: any,
  ) {
    return context
      .dispatch('getServices', {
        duration: params.duration,
        serviceReq: params.serviceReq,
        permissions: params.permissions,
      })
      .then(() => {
        if (store.getters['globalState/app/sideNav'].name !== 'Settings') {
          context.dispatch('getServiceEndpoints', {
            duration: params.duration,
          });
        }
      })
      .then(() => {
        if (store.getters['globalState/app/sideNav'].name !== 'Settings') {
          context.dispatch('getServiceInstances', {
            duration: params.duration,
          });
        }
      })
      .then(() => {
        if (store.getters['globalState/app/sideNav'].name !== 'Settings') {
          context.dispatch('getServiceDatabases', {
            duration: params.duration,
            serviceId: context.state.currentService.key,
          });
        }
      })
      .catch((err) => {
        console.log('Error occured', err);
      });
  },
  getServiceApdex(context: { commit: Commit }, params: { serviceId: string }) {
    if (!params.serviceId) {
      return;
    }
    return graphQl
      .query('queryApdex')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit('setCurrentServiceApdex', res.data.data.Int);
      });
  },
  updateServiceApdex(
    context: { commit: Commit },
    params: {
      apdexCreationReq: {
        serviceId: any;
        value: Number;
      };
    },
  ) {
    if (!params.apdexCreationReq.serviceId) {
      return;
    }
    return graphQl
      .query('queryApdexMutation')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit('setCurrentServiceApdex', params.apdexCreationReq.value);
      });
  },
  getDataRetentionConfig(
    context: { commit: Commit },
    params: { serviceId: string },
  ) {
    if (!params.serviceId) {
      return;
    }
    return graphQl
      .query('queryDataRetentionConfig')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit(
          'setSaveAllErrors',
          res.data.data.dataRetentionResponse.saveAllErrors,
        );
        context.commit(
          'setMinTraceLatency',
          res.data.data.dataRetentionResponse.minTraceLatency,
        );
        context.commit(
          'setMaxSpansPerTraces',
          res.data.data.dataRetentionResponse.maxSpansPerTraces,
        );
        context.commit(
          'setMinDbQueryLatency',
          res.data.data.dataRetentionResponse.minDbQueryLatency,
        );
      });
  },
  updateDataRetentionConfig(
    context: { commit: Commit },
    params: {
      dataRetentionRequest: {
        serviceId: any;
        saveAllErrors: boolean;
        minTraceLatency: Number;
        maxSpansPerTraces: Number;
        minDbQueryLatency: Number;
      };
    },
  ) {
    if (!params.dataRetentionRequest.serviceId) {
      return;
    }
    return graphQl
      .query('saveDataRetentionConfig')
      .params(params)
      .then((res: AxiosResponse) => {
        context.commit(
          'setSaveAllErrors',
          params.dataRetentionRequest.saveAllErrors,
        );
        context.commit(
          'setMinTraceLatency',
          params.dataRetentionRequest.minTraceLatency,
        );
        context.commit(
          'setMaxSpansPerTraces',
          params.dataRetentionRequest.maxSpansPerTraces,
        );
        context.commit(
          'setMinDbQueryLatency',
          params.dataRetentionRequest.minDbQueryLatency,
        );
      });
  },
};

export default actions;
